import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 22L17 17H13V7H17L12 2L7 7H11V17H7L12 22Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "MoveVertical"
);
